module.exports = __webpack_public_path__ + "static/media/u35_2.3d9d6a83.mp3";